"use strict";

import * as Tabs from "components/Tabs";
document.addEventListener("DOMContentLoaded", function () {
  Tabs.init();
});
window.addEventListener("load", function () {});
